module.exports = __webpack_public_path__ + "static/media/profile.dd4f7caa.svg";